export default function HeroSection({ onCtaClick }) {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: "var(--blush)" }}
    >
      {/* Animated depth rings */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="depth-ring" />
        <div className="depth-ring" />
        <div className="depth-ring" />
        <div className="depth-ring" />
        <div className="depth-ring" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <h1
          data-testid="hero-heading"
          className="animate-fade-up"
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "clamp(2.75rem, 7vw, 5rem)",
            fontWeight: 600,
            lineHeight: 1.08,
            color: "var(--charcoal)",
            marginBottom: "1.5rem",
            letterSpacing: "-0.02em",
          }}
        >
          Technology with soul
        </h1>

        <p
          data-testid="hero-subheading"
          className="animate-fade-up delay-200"
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: "clamp(1.05rem, 2.2vw, 1.25rem)",
            lineHeight: 1.7,
            color: "var(--charcoal-light)",
            maxWidth: "580px",
            margin: "0 auto 2.5rem",
            fontWeight: 400,
          }}
        >
          We build products for the parts of human life that matter most —
          connection, growth, belonging, and meaning.
        </p>

        <button
          data-testid="hero-cta-button"
          className="btn-coral animate-fade-up delay-400"
          onClick={onCtaClick}
        >
          Get early access
        </button>
      </div>
    </section>
  );
}
